import React from "react";
import { Mail, MessageCircle, Phone, ShieldCheck } from "lucide-react";
import INFO from "../../data/user";

import "./styles/footer.css";

const experienceStats = [
	{ value: "15m+", label: "People reached" },
	{ value: "1,000+", label: "Talks delivered" },
	{ value: "200+", label: "Client partnerships" },
	{ value: "175k+", label: "Followers online" },
];

const clientNames = [
	"FNB",
	"CRU",
	"MSX International",
	"Motus",
	"Volkswagen",
	"WellSpan Health",
	"Tshwane University",
	"Bidvest McCarthy",
	"Standard Bank",
	"SARS",
	"Capitec",
	"Accenture",
	"GIBS",
	"Amka",
	"BMW",
	"Nutun",
	"ABB",
	"Transnet",
];

const Footer = () => {
	return (
		<footer className="footer" aria-label="Jabu Zwane experience and contact information">
			<div className="footer-inner">
				<div className="footer-experience">
					<div className="footer-heading">
						<span className="footer-eyebrow">Track record</span>
						<h2>Experience that speaks for itself</h2>
						<p>
							Two decades of speaking, coaching and counselling work with teams
							and leaders across industries.
						</p>
					</div>

					<div className="footer-stats" aria-label="Experience highlights">
						{experienceStats.map((stat) => (
							<div className="footer-stat" key={stat.label}>
								<strong>{stat.value}</strong>
								<span>{stat.label}</span>
							</div>
						))}
					</div>

					<div className="footer-clients">
						<h3>Organizations I've worked with</h3>
						<ul className="footer-client-list">
							{clientNames.map((name) => (
								<li key={name}>{name}</li>
							))}
						</ul>
					</div>
				</div>

				<div className="footer-bottom">
					<div className="footer-contact" aria-label="Contact Jabu Zwane">
						<a href={`tel:${INFO.main.phone.replace(/\D/g, "")}`}>
							<Phone size={16} aria-hidden="true" />
							<span>{INFO.main.phone}</span>
						</a>
						<a href={INFO.socials.Whatsapp} target="_blank" rel="noreferrer">
							<MessageCircle size={16} aria-hidden="true" />
							<span>WhatsApp</span>
						</a>
						<a href={`mailto:${INFO.main.email}`}>
							<Mail size={16} aria-hidden="true" />
							<span>{INFO.main.email}</span>
						</a>
					</div>

					<div className="footer-privacy" role="note">
						<div className="footer-privacy-icon" aria-hidden="true">
							<ShieldCheck size={17} strokeWidth={2.2} />
						</div>
						<div>
							<strong>POPIA-aligned privacy</strong>
							<span>We handle your personal information responsibly in line with South Africa's POPIA.</span>
						</div>
					</div>

					<div className="footer-credits">
						<div className="footer-credits-text">
							© {new Date().getFullYear()} Jabu Zwane. All Rights Reserved.
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
